import { FC, InputHTMLAttributes, ReactNode, useRef } from 'react'
import { OptionButtonContainer } from './styles'
import { useErrors } from 'src/context/errors';

interface OptionButtonProps extends InputHTMLAttributes<HTMLInputElement> {
  children?: ReactNode;
  isIncorrect?: boolean;
  errorCode?: string;
}

const OptionButton: FC<OptionButtonProps> = ({ checked, children, isIncorrect, errorCode = '', ...rest }) => {
  const inputRef = useRef<HTMLInputElement>(null)
  const { hasError } = useErrors()

  isIncorrect = hasError(errorCode) || isIncorrect

  const onRadioClick = () => {
    if(!!inputRef && !!inputRef.current) inputRef.current.click()
  }

  return (
    <OptionButtonContainer isIncorrect={isIncorrect} checked={!!checked} onClick={onRadioClick}>
      <input ref={inputRef} {...rest} checked={checked} type="radio"/>
      {children}
    </OptionButtonContainer>
  )
}

export default OptionButton